import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  FileButton,
  Grid,
  Group,
  Select,
  Textarea,
  TextInput
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import {
  IconArrowBack,
  IconArrowUp,
  IconCheck
} from "@tabler/icons-react";
import dayjs from "dayjs";
import { useState } from "react";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { API_ROUTE } from "../../../const/apiRoute";
import { api } from "../../../library/axios";

const CongvanCreate = () => {
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const [congvandata, setCongvanData] = useState<any>({
    id: 0,
    loaiCongVan: "đến",
    donVi: "",
    soVanBan: "",
    soDen: "",
    soDi: "",
    ngayDen: dayjs().format(),
    ngayPhatHanh: dayjs().format(),
    soBanPhatHanh: 1,
    ngayCoHieuLuc: dayjs().format(),
    ngayHetHieuLuc: dayjs().add(1, "month").endOf("day").format(),
    noiGui: "",
    noiNhan: "",
    nguoiKy: "",
    loaiVanBan: "Nghị quyết",
    mucDoKhanCap: "Bình thường",
    mucDoBaoMat: "Thường",
    soTrang: 1,
    dangVanBan: "Giấy",
    viTriLuuTru: "",
    tepDinhKem: "",
    trichYeuNoiDung: "",
    nguoiXuLy: "",
    tinhTrangXuLy: "Chưa xử lý",
    hanXuLy: dayjs().format(),
    choPhepTraCuu: 0,

    createdBy: 0,
    createdDate: dayjs().format(),
    lastUpdatedBy: 0,
    lastUpdatedDate: dayjs().format(),
  });
  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result?.toString().split(",")[1] || "";
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  const handleInputChange = (field: keyof any, value: any) => {
    setCongvanData((prev: any) => {
      let newData = { ...prev, [field]: value };

      if (field === "loaiCongVan") {
        if (value === "đến") {
          newData.soDi = null;
          newData.ngayPhatHanh = null;
        } else if (value === "đi") {
          newData.soDen = null;
          newData.ngayDen = null;
        }
      }
      if (field === "ngayCoHieuLuc") {
        const ngayCoHieuLucFormatted = formatDateNotTimeZone(value);
        newData.ngayCoHieuLuc = ngayCoHieuLucFormatted;

        const nextMonth = dayjs(ngayCoHieuLucFormatted)
          .add(1, "month")
          .endOf("day")
          .format();
        newData.ngayHetHieuLuc = nextMonth;
      }
      return newData;
    });
  };

  const validateForm = (): boolean => {
    if (!congvandata.soVanBan.trim()) {
      NotificationExtension.Fails("Số văn bản là bắt buộc");
      return false;
    }

    if (!congvandata.loaiVanBan) {
      NotificationExtension.Fails("Loại văn bản là bắt buộc");
      return false;
    }

    if (!congvandata.trichYeuNoiDung.trim()) {
      NotificationExtension.Fails("Trích yếu nội dung là bắt buộc");
      return false;
    }
    if (
      dayjs(congvandata.ngayCoHieuLuc).isAfter(
        dayjs(congvandata.ngayHetHieuLuc)
      )
    ) {
      NotificationExtension.Fails(
        "Ngày có hiệu lực phải trước hoặc bằng ngày hết hiệu lực"
      );
      return false;
    }

    if (congvandata.loaiCongVan === "đến") {
      if (!congvandata.soDen?.trim()) {
        NotificationExtension.Fails("Số đến là bắt buộc với công văn đến");
        return false;
      }
      if (!congvandata.ngayDen) {
        NotificationExtension.Fails("Ngày đến là bắt buộc với công văn đến");
        return false;
      }
    } else {
      if (!congvandata.soDi?.trim()) {
        NotificationExtension.Fails("Số đi là bắt buộc với công văn đi");
        return false;
      }
      if (!congvandata.ngayPhatHanh) {
        NotificationExtension.Fails(
          "Ngày phát hành là bắt buộc với công văn đi"
        );
        return false;
      }
      if (!congvandata.tepDinhKem) {
        NotificationExtension.Fails("Tệp đính kèm là bắt buộc");
        return false;
      }
    }
    return true;
  };

  const handleCreate = async () => {
    if (!validateForm()) return;

    setLoading(true);

    try {
      let dataToSend: Partial<any> = {
        ...congvandata,
        createdBy: 0,
        lastUpdatedBy: 0,
        createdDate: new Date().toISOString(),
        lastUpdatedDate: new Date().toISOString(),
      };

      if (congvandata.loaiCongVan === "đến") {
        dataToSend.ngayPhatHanh = null;

        dataToSend.soDi = null;
      } else if (congvandata.loaiCongVan === "đi") {
        dataToSend.ngayDen = null;
        dataToSend.soDen = null;
      }

      const response = await api.post(
        `${API_ROUTE}/api/congvan/create`,
        dataToSend
      );

      NotificationExtension.Success("Tạo công văn thành công!");
      setTimeout(() => {
        window.history.back();
      }, 500);
    } catch (error) {
      // Xử lý lỗi
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Group justify="space-between" align="center" mb="xs">
        <_breadcrumb />
        <Group gap={10}>
          <Button
            type="button"
            color="red"
            variant="outline"
            leftSection={<IconArrowBack />}
            onClick={() => window.history.back()}
            disabled={loading}
          >
            Quay lại
          </Button>
          <Button
            color="teal"
            variant="outline"
            leftSection={<IconCheck size={18} />}
            onClick={handleCreate}
            loading={loading}
          >
            Tạo công văn
          </Button>
        </Group>
      </Group>

      <Fieldset legend="Thông tin công văn">
        <Grid>
          <Grid.Col span={4}>
            <Select
              label="Loại công văn"
              data={[
                { label: "Công văn đến", value: "đến" },
                { label: "Công văn đi", value: "đi" },
              ]}
              value={congvandata.loaiCongVan}
              onChange={(value) =>
                handleInputChange("loaiCongVan", value || "đến")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            {congvandata.loaiCongVan === "đến" ? (
              <TextInput
                label="Số đến"
                value={congvandata.soDen ?? ""}
                onChange={(e) =>
                  handleInputChange("soDen", e.currentTarget.value)
                }
              />
            ) : (
              <TextInput
                label="Số đi"
                value={congvandata.soDi ?? ""}
                onChange={(e) =>
                  handleInputChange("soDi", e.currentTarget.value)
                }
              />
            )}
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Loại văn bản"
              data={[
                "Nghị quyết",
                "Thông báo",
                "Quyết định",
                "Hợp đồng",
                "Công văn",
                "Thông tư",
                "Thư",
                "Nghị định",
                "Tờ trình",
              ]}
              required
              value={congvandata.loaiVanBan}
              onChange={(value) => handleInputChange("loaiVanBan", value || "")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Số văn bản"
              required
              value={congvandata.soVanBan}
              onChange={(e) =>
                handleInputChange("soVanBan", e.currentTarget.value)
              }
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <TextInput
              label="Nơi gửi"
              value={congvandata.noiGui}
              onChange={(e) =>
                handleInputChange("noiGui", e.currentTarget.value)
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Người ký"
              value={congvandata.nguoiKy}
              onChange={(e) =>
                handleInputChange("nguoiKy", e.currentTarget.value)
              }
            />
          </Grid.Col>
          {congvandata.loaiCongVan === "đến" && (
            <Grid.Col span={4}>
              <DateTimePicker
                label="Ngày đến"
                value={
                  congvandata.ngayDen ? new Date(congvandata.ngayDen) : null
                }
                onChange={(date) =>
                  handleInputChange(
                    "ngayDen",
                    formatDateNotTimeZone(date || new Date())
                  )
                }
              />
            </Grid.Col>
          )}

          {congvandata.loaiCongVan === "đi" && (
            <Grid.Col span={4}>
              <DateTimePicker
                label="Ngày phát hành"
                value={
                  congvandata.ngayPhatHanh
                    ? new Date(congvandata.ngayPhatHanh)
                    : null
                }
                onChange={(date) =>
                  handleInputChange(
                    "ngayPhatHanh",
                    formatDateNotTimeZone(date || new Date())
                  )
                }
              />
            </Grid.Col>
          )}
          <Grid.Col span={4}>
            <DateTimePicker
              label="Ngày có hiệu lực"
              value={new Date(congvandata.ngayCoHieuLuc)}
              onChange={(date) =>
                handleInputChange(
                  "ngayCoHieuLuc",
                  formatDateNotTimeZone(date || new Date())
                )
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <DateTimePicker
              label="Ngày hết hiệu lực"
              value={new Date(congvandata.ngayHetHieuLuc)}
              onChange={(date) =>
                handleInputChange(
                  "ngayHetHieuLuc",
                  formatDateNotTimeZone(date || new Date())
                )
              }
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <Select
              label="Mức độ khẩn cấp"
              data={["Bình thường", "Khẩn", "Hỏa tốc"]}
              value={congvandata.mucDoKhanCap}
              onChange={(value) =>
                handleInputChange("mucDoKhanCap", value || "Bình thường")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Mức độ bảo mật"
              data={["Thường", "Mật", "Tuyệt mật"]}
              value={congvandata.mucDoBaoMat}
              onChange={(value) =>
                handleInputChange("mucDoBaoMat", value || "Thường")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Dạng văn bản"
              data={["Bản giấy", "Điện tử"]}
              value={congvandata.dangVanBan}
              onChange={(value) =>
                handleInputChange("dangVanBan", value || "Bản giấy")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Số trang"
              type="number"
              value={congvandata.soTrang}
              onChange={(e) =>
                handleInputChange("soTrang", parseInt(e.currentTarget.value))
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Đơn vị"
              value={congvandata.donVi}
              onChange={(e) =>
                handleInputChange("donVi", e.currentTarget.value)
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Vị trí lưu trữ"
              value={congvandata.viTriLuuTru}
              onChange={(e) =>
                handleInputChange("viTriLuuTru", e.currentTarget.value)
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Số bản phát hành"
              type="number"
              value={congvandata.soBanPhatHanh}
              onChange={(e) =>
                handleInputChange(
                  "soBanPhatHanh",
                  parseInt(e.currentTarget.value)
                )
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Nơi nhận"
              value={congvandata.noiNhan}
              onChange={(e) =>
                handleInputChange("noiNhan", e.currentTarget.value)
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Đính kèm"
              placeholder="Chọn file .docx nhỏ hơn 1MB"
              value={file?.name || ""}
              readOnly
              rightSection={
                <FileButton
                  onChange={async (selectedFile) => {
                    if (!selectedFile) return;

                    if (
                      selectedFile.type !==
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                      selectedFile.size > 1024 * 1024
                    ) {
                      NotificationExtension.Fails(
                        "Chỉ chấp nhận file .docx nhỏ hơn 1MB!"
                      );
                      return;
                    }

                    const base64String = await convertFileToBase64(
                      selectedFile
                    );

                    setFile(selectedFile);
                    setCongvanData((prev: any) => ({
                      ...prev,
                      tepDinhKem: base64String,
                    }));
                  }}
                  accept=".docx"
                >
                  {(props) => (
                    <Button
                      {...props}
                      size="xs"
                      variant="light"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IconArrowUp size={16} />
                    </Button>
                  )}
                </FileButton>
              }
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Textarea
              label="Trích yếu nội dung"
              minRows={6}
              rows={6}
              withAsterisk
              value={congvandata.trichYeuNoiDung}
              onChange={(e) =>
                handleInputChange("trichYeuNoiDung", e.currentTarget.value)
              }
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <TextInput
              label="Người xử lý"
              value={congvandata.nguoiXuLy}
              onChange={(e) =>
                handleInputChange("nguoiXuLy", e.currentTarget.value)
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Tình trạng xử lý"
              data={["Chờ xử lý", "Đang xử lý", "Đã xử lý"]}
              value={congvandata.tinhTrangXuLy}
              onChange={(value) =>
                handleInputChange("tinhTrangXuLy", value || "Chờ xử lý")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <DateTimePicker
              label="Hạn xử lý"
              value={new Date(congvandata.hanXuLy)}
              onChange={(date) =>
                handleInputChange(
                  "hanXuLy",
                  date?.toISOString() || new Date().toISOString()
                )
              }
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Checkbox
              label="Không cho phép nhân viên tra cứu"
              checked={!congvandata.choPhepTraCuu}
              onChange={(e) =>
                handleInputChange(
                  "choPhepTraCuu",
                  e.currentTarget.checked ? 0 : 1
                )
              }
            />
          </Grid.Col>
        </Grid>
      </Fieldset>
    </Box>
  );
};

export default CongvanCreate;
